import { useQuery } from '@tanstack/react-query';
import { getConsumerRegistrationDeletion } from '../services/requests';
import type { ConsumerRegistrationDeletionRequest } from '../schemas/auth';

export const useConsumerRegistrationDeletion = (params?: ConsumerRegistrationDeletionRequest) => {
  return useQuery({
    queryKey: ['consumerRegistrationDeletion', params?.minDate, params?.maxDate],
    queryFn: () => getConsumerRegistrationDeletion(params),
    enabled: !!params?.minDate && !!params?.maxDate, // Parametreler varsa çalışacak
  });
};
